<template>
    <div class="teacher">
        <!-- banner -->
        <div class="banner">
            <div class="img"><img src="@/assets/img/pilotage/ggu_logo.png" alt=""></div>
            <p>领航研导师库</p>
        </div>
        <!-- list -->
        <div class="list">
            <ul>
                <li v-for="(item,index) in teacherList" :key="index">
                    <div class="left">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="right">
                        <p class="name">{{item.name}} <span>{{item.label}}</span></p>
                        <p class="info">{{item.info}}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

// import api from "@/api/apply";   
export default {
    data() {
        return {
            dataImgUrl:"http://www.gguconsulting.com/try/sbm/Public/GGUExper_files/",
            
            teacherList:[{
                name:"婷婷学姐",
                img:require("@/assets/img/pilotage/ting.jpg"),
                label:"清华大学硕士",
                info:"2017年清华大学美术学院艺术硕士考研上岸，总分364分，初试全国第一名。十分熟悉清华美院各专业报考难度，擅长专业课应试技巧。2017年9月加入领航研，对考生进行一对一美术理论和手绘专业课辅导。辅导的四位同学中：2018年辅导的三位同学，均顺利通过清华美院考研初试（具体见案例），并包揽2018年清华美院艺术硕士全国第一、第二名；另一位同学于2019年一战上岸清华美院。"
            },{
                name:"Frank学长",
                img:require("@/assets/img/pilotage/frank.jpg"),
                label:"清华大学硕士",
                info:"2018年考研，清华大学法学院法学硕士录取，初试成绩340+分，复试成绩93分。初试复习三个月，复试复习一个月，复试成绩为本专业第一。曾担任知名教育机构法学考研全程班讲师。熟悉老师的授课内容与本学科出题热点，擅长指导考生在短期内有的放矢地复习，在复试中取得逆袭。"
            },{
                name:"萌萌学姐",
                img:require("@/assets/img/pilotage/meng.jpg"),
                label:"清华大学硕士",
                info:"2020二战考研上岸清华五道口金融专硕，总分385+，本科南方某211经济类专业。经历两年备考，深知五道口备考的关键，第二年考试专业课成绩大幅提升10余分，愿意跟学弟学妹无私分享两年整理的专业课备考真题、笔记以及其他科目复习资料。"
            },{
                name:"陈学长",
                img:require("@/assets/img/pilotage/chen.jpg"),
                label:"北京大学硕士",
                info:"本科专业为工科类，2020年一战考研上岸北京大学社会工作硕士。考研初试总分388分，其中专业课分数为：社会工作原理119分（专业第二），社会工作实务125分（专业第一）。熟悉最新考法考情，对于理工类背景学生准备文科类专业课有独特见解。"
            },{
                name:"沈学姐",
                img:require("@/assets/img/pilotage/shen.jpg"),
                label:"北京大学硕士",
                info:"2020年北京大学艺术学院电影系硕士，初试总分382分，其中艺术基础135分，电影创意理论126分。本科就读于中国戏曲学院，深谙北京电影学院、中央戏剧学院、北大艺术学院等院校的电影专业的录取差别，有丰富的辅导经验。"
            },{
                name:"李学长",
                img:require("@/assets/img/pilotage/li.jpg"),
                label:"北京大学硕士",
                info:"本科来自北方某普通高校，2018年跨专业二战考研上岸，北京大学汇丰商学院（深圳）金融硕士，总分384分，其中数学三133分，专业课114分。整理了丰富的汇丰金融硕士真题、笔记资料，对于汇丰初试专业课考法有深刻见解。"
            },{
                name:"乐乐学姐",
                img:require("@/assets/img/pilotage/le.jpg"),
                label:"北京大学硕士",
                info:"本科来自某“双非”院校国际金融专业，2017年一战考研上岸北京大学光华管理学院MPAcc会计硕士专业，初试总分240分，复试总分77分。对于“双非”考生择校定位、专业选择有深刻见解，擅长辅导考研会计专业课及光华管理学院复试。"
            },{
                name:"波波学长",
                img:require("@/assets/img/pilotage/bobo.png"),
                label:"北京大学硕士",
                info:"本科专业为机械工程，跨专业考研北京大学工学院工程管理硕士。考研初试总分194分，其中管理类联考综合124分，综合排名第4名。对于北大管理类硕士专业选择、备考方案、申请材料、面试流程等较为熟悉，善于帮学生准备有针对性的研究生申请方案，助力学生上岸清北全日制研究生。"
            },{
                name:"薄荷学姐",
                img:require("@/assets/img/pilotage/bo.png"),
                label:"北京大学硕士",
                info:"本科上海某211高校，2020年一战跨考上岸，被北大软件与微电子学院金融科技专业录取，综合排名第五，考研初试总分411分，其中经济学综合专业课124分，复试分数88分。对于北京大学经济类专业较为了解，善于指导学生进行专业院校选择、经济类专业课备考。"
            },{
                name:"邱学长",
                img:require("@/assets/img/pilotage/qiu.jpg"),
                label:"上海交通大学硕士",
                info:"2020高分上岸上海交通大学动力工程专业，初试成绩380+，专业排名前五，复试排名第二。本科毕业于中部某211院校，从10月份开始复习用较短的时间学习，在时间安排和制定计划表方面有一定优势，可协助督导复习。对于考研专业课复习重点有一定心得~"
            },{
                name:"李学姐",
                img:require("@/assets/img/pilotage/li_n.jpg"),
                label:"复旦大学硕士",
                info:"2019年一战考入复旦大学基础医学院病理系，本科毕业于二本医学院校，5个月备考后成功考入复旦大学。通过总结摸索出一套适合757基础医学综合的高效方法，愿意向学弟学妹提供复习笔记、真题、参考资料。"
            },{
                name:"魏学姐",
                img:require("@/assets/img/pilotage/wei.png"),
                label:"复旦大学硕士",
                info:"2020年跨校跨专业考入复旦大学国际商务专业硕士，本科毕业于华东理工大学工科专业，初试总分368分，其中专业课114分（专业前5）。二战考研，深知备考关键，手头复习资料丰富。"
            },{
                name:"王学长",
                img:require("@/assets/img/pilotage/wang_.jpg"),
                label:"浙江大学硕士",
                info:"2020一战考研上岸浙江大学计算机科学与技术专业，曾在知名考研机构进行考研数学的授课。针对招考规则比较复杂、报录比不透明的浙大计算机专业有一定心得，专业课408基础扎实，善于把定理定义用形象化的比喻来讲解，让同学更方便的理解与记忆。"
            },{
                name:"陈学长",
                img:require("@/assets/img/pilotage/chen_.jpg"),
                label:"浙江大学硕士",
                info:"2020一战考研上岸浙江大学机械工程专业，初复试成绩均排名第二，初试成绩为408分，其中专业课（机械设计基础）139分，本科毕业于浙江某双非院校。专业课资料笔记均在手头，可以指导学员高效学习专业课。"
            },{
                name:"王学长",
                img:require("@/assets/img/pilotage/wang.jpg"),
                label:"中国人民大学硕士",
                info:"2015年中国人民大学法学院考研状元，总分401分（英语67分，政治73分，专业一133分，专业二128分）。持续多年跟踪最新考研政策，可为考生提供独家复习笔记及法硕备考资料。考研辅导经验丰富，近年来有多位学生成功上岸人大法学院、清华法学院等知名院校。"
            },{
                name:"段学长",
                img:require("@/assets/img/pilotage/duan.jpg"),
                label:"中国人民大学硕士",
                info:"2019级中国人民大学经济学硕士，初试分数392分。对于人大802经济学专业课有独到见解，整理了近20年专业课考研真题。2020年辅导的多名考生均高分通过人大经济类专业初试，顺利上岸人大应用经济学院、社会与人口学院和劳动人事学院的相关专业。"
            },{
                name:"潇潇学姐",
                img:require("@/assets/img/pilotage/xiao.jpg"),
                label:"南京大学硕士",
                info:"2020考研上岸南京大学软件工程专业，10-12月备考，最终总分370+，当年南大计算机考研前三名。保留有专业课的笔记，和简单的数学笔记，可根据学生情况给予建议和学习指导。"
            },{
                name:"Andy学长",
                img:require("@/assets/img/pilotage/andy.jpg"),
                label:"武汉大学硕士",
                info:"2020年武汉大学公共管理（行政管理）专业，初试总分405+，超分数线近40分，其中初试专业课二成绩全院第一，有敏锐的时政热点应用能力，乐于分享交流自身经验。"
            },{
                name:"张学姐",
                img:require("@/assets/img/pilotage/zhang.jpg"),
                label:"中山大学硕士",
                info:"2020年一战考研上岸，中山大学马克思主义学院思想政治教育专业，初试成绩379，综合成绩专业第九。本科毕业于西北某211院校，曾从不同渠道收集多种备考资料，真题笔记齐全。乐于为学弟学妹提供指导。"
            },{
                name:"小王学长",
                img:require("@/assets/img/pilotage/xiaowang.jpg"),
                label:"厦门大学硕士",
                info:"2020上岸厦门大学概率论与数理统计专业，本科专业为电气工程及其自动化。初试总分348分，初试一志愿唯一上线考生，初试复试均第一。对跨专业考研有独到经验，善于辅导学生初试、复试备考。"
            }]
        }
    },
    methods:{
        //获取offer数据
        async getApplyData(){
            try {
                let re = await api.apply_undergraduate_list();
                this.applyData = re.data.data.list;
            } catch (error) {
                console.error(error);
            }
        }
    },
    created(){
        
        // this.getApplyData();
    }
}
</script>

<style lang="less" scoped>
.teacher {
    background:#fff;
    // font-family: 'PingFang Regular';
    .banner {
        width: 100%;
        height: 360px;
        position: relative;
        background:url("../../assets/img/pilotage/apply_b_t.jpg") no-repeat;
        background-size:100% auto;
        background-position:0 center;
        p {
            padding-top: 125px;
            text-align: center;
            font-size: 47px;
            color: #fff;
            span {
                color: #da1f1f;
            }
        }
        .img {
            width: 170px;
            // height: 38px;
            position: absolute;
            top: 40px;
            left: 43px;
            img {
                width: 100%;
                // height: 100%;
            }
        }
    }
    .list{
        padding:0 25px 100px;
        margin-top:40px;
        ul{
            // margin-top:20px;
            li{
                border:1px solid rgba(204,204,204,1);
                border-radius:20px;
                margin-bottom:20px;
                display:flex;
                padding:37px 28px;
                .left{
                    width:114px;
                    height:114px;
                    background:#ddd;
                    margin-right:30px;
                    img{
                        width:100%;
                        height:100%;
                    }
                }
                .right{
                    flex:1;
                    .name{
                        font-size:32px;
                        color:#000000;
                        span{
                            display:inline-block;
                            padding:0px 15px;
                            border-radius:17px;
                            background:#da1f1f;
                            color:#fff;
                            font-size:24px;
                            line-height:32px;
                            margin-left:15px;
                            vertical-align: middle;
                            margin-top:-10px;
                        }
                    }
                    .info{
                        margin-top:20px;
                        font-size:26px;
                        color:#4D4D4D;
                        line-height:44px;
                    }
                }
            }
        }
    }
    .loading{
        text-align: center;
        height:200px;
        .van-loading{
            width:100%;
            margin-top:200px;
            color:#000 !important;
        }
    }
}
</style>